var contentDivs = document.getElementsByClassName("content");
var clickDivs = document.getElementsByClassName("clickDiv");
var clickHide = document.getElementsByClassName("cstm-style");
var nextButton = document.getElementById("nextButton");
var selectButton = document.getElementById("SelectOption");
var prevButton = document.getElementById("prevButton");
// var totalButton = document.getElementById("total-price");
var addToCartButton = document.getElementById("addToCartButton");
var mainImageContainer = document.querySelector(".main-child-one.nekless");
var charmImageContainer = document.querySelector(".main-charm");
var engravingInputContainer = document.getElementById(
  "engravingInputContainer"
);
var doneButton = document.getElementById("doneButton");
var loader = document.getElementById("loader");
var currentStep = 0;

// Function to hide all content divs and show the specified one
function showContent(contentId) {
  for (var i = 0; i < contentDivs.length; i++) {
    contentDivs[i].style.display = "none";
  }
  var contentToShow = document.getElementById(contentId);
  if (contentToShow) {
    contentToShow.style.display = "block";
  }
  for (var i = 0; i < clickDivs.length; i++) {
    clickDivs[i].style.display = "none";
  }
  selectButton.disabled = true;
  addToCartButton.style.display = "none";
  // totalButton.style.display = "none";
  nextButton.style.display = "none";
  // nextButton.style.display = "flex";
  selectButton.style.display = "block";
  prevButton.style.display = "block"; // Show prev button when content is shown
}
// Adding click event listeners to clickDivs
for (var i = 0; i < clickDivs.length; i++) {
  clickDivs[i].addEventListener("click", function () {
    // Check if the div with class "step-img index-4" is empty
    var stepImgIndex4 = document.querySelector(".step-img.index-4");

    // Only proceed if this element exists and is not empty
    if (!stepImgIndex4 || stepImgIndex4.innerHTML.trim() === "") {
      // Check if this is the last clickDiv, then disable the click
      if (this === clickDivs[clickDivs.length - 1]) {
        return; // Exit the function to keep the last clickDiv disabled
      }
    }

    // Proceed with the click event if above conditions are not met
    if (!this.classList.contains("disabled")) {
      var contentId = this.getAttribute("data-content");
      showContent(contentId);
      currentStep = parseInt(contentId.replace("content", "")) - 1;
      selectButton.disabled = true;
      selectButton.style.display = "block";

      nextButton.style.display = "none";
      for (var j = 0; j <= currentStep; j++) {
        clickDivs[j].classList.remove("disabled");
        clickDivs[j].classList.add("enable");
      }
    }
  });
}


// Adding click event listeners to list items
var listItems = document.querySelectorAll(".content .div");
listItems.forEach(function (item) {
  item.addEventListener("click", function () {
    selectButton.disabled = false;
    selectButton.style.display = "block";
    nextButton.style.display = "none";
    listItems.forEach(function (li) {
      li.classList.remove("selected");
    });
    this.classList.add("selected");
  });
});
function setupImageSelection(contentId, imgClass) {
  var editItems = document.querySelectorAll(`#${contentId} .div`);
  var beforeEnableDiv = document.querySelector(`.before-enable .${imgClass} img`);

  editItems.forEach(function (div) {
    div.addEventListener("click", function () {
      selectButton.disabled = false;
      selectButton.style.display = "block";
      nextButton.style.display = "none";

      // Remove "selected" class from all .show-pick inside .div before adding it to the clicked one
      editItems.forEach(function (item) {
        item.querySelector(".show-pick").classList.remove("selected");
      });

      var showPick = this.querySelector(".show-pick");
      showPick.classList.add("selected");

      // Get image attributes from the selected item
      var imgSrc = showPick.querySelector("img").getAttribute("src");
      var imgSrcSet = showPick.querySelector("img").getAttribute("srcset");

      // Update the image in the corresponding .before-enable div
      beforeEnableDiv.src = imgSrc;
      if (imgSrcSet) {
        beforeEnableDiv.srcset = imgSrcSet;
      } else {
        beforeEnableDiv.removeAttribute("srcset");
      }
      beforeEnableDiv.classList.remove("sb");
    });
  });
}

// Call function for each step
setupImageSelection("content1", "first-img");
setupImageSelection("content2", "second-img");
setupImageSelection("content3", "third-img");
setupImageSelection("content4", "fourth-img");
setupImageSelection("content5", "fifth-img");
setupImageSelection("content6", "sixth-img");



//
var formData = {
  items: [],
};

const divs = document.querySelectorAll(".clickDiv");
const products = document.querySelectorAll(".div");
let selectedPrices = [];

// Function to update the total price
const updateTotalPrice = () => {
  const totalPrice = selectedPrices.reduce((sum, price) => sum + price, 0);
  document.getElementById("total-price").textContent = `${totalPrice}`;
};

products.forEach((product) => {
  product.addEventListener("click", () => {
    const divIndex = parseInt(product.getAttribute("data-div-index"));
    const price = parseFloat(product.getAttribute("data-price"));

    // Remove 'get-price' class from previous product in the same div
    products.forEach((p) => {
      if (parseInt(p.getAttribute("data-div-index")) === divIndex) {
        p.classList.remove("get-price");
      }
    });

    // Add 'get-price' class to clicked product
    product.classList.add("get-price");

    // Update the selectedPrices array
    selectedPrices[divIndex] = price;
  });
});

const removeButtons = document.querySelectorAll(".remove-button");
removeButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const index = parseInt(button.getAttribute("data-index"));

    // Remove the price at the given index
    if (selectedPrices[index] !== undefined) {
      selectedPrices[index] = 0; // Or use `selectedPrices.splice(index, 1);` to remove it
      updateTotalPrice();
    }
  });
});

// Check if each remove button exists before adding an event listener
const remove1 = document.getElementById("remove1");
if (remove1) {
  remove1.addEventListener("click", function () {
    const hideOne = document.querySelector(".step-img.index-1");
    const beforeFir = document.querySelector(".before-fir img");
    const borderRemove = document.querySelector(".selected");
    hideOne.innerHTML = "";
    beforeFir.classList.add("sb");
    beforeFir.src = "https://cdn.shopify.com/s/files/1/0681/7054/7447/files/e356d9c8-1ebd-49e5-a8da-03dcd6cf3fcd.png?v=1729840924";
    borderRemove.style.border = "none";
  });
}

const remove2 = document.getElementById("remove2");
if (remove2) {
  remove2.addEventListener("click", function () {
    const hideTwo = document.querySelector(".step-img.index-2");
    hideTwo.innerHTML = "";
    const beforeSec = document.querySelector(".before-sec img");
    beforeSec.classList.add("sb");
    beforeSec.src = "https://cdn.shopify.com/s/files/1/0681/7054/7447/files/89b3b478-5219-49f5-bc49-4285d96e0dc3.png?v=1729840924";
  });
}

const remove3 = document.getElementById("remove3");
if (remove3) {
  remove3.addEventListener("click", function () {
    const hideThree = document.querySelector(".step-img.index-3");
    hideThree.innerHTML = "";
    const beforeThird = document.querySelector(".before-third img");
    beforeThird.classList.add("sb");
    beforeThird.src = "https://cdn.shopify.com/s/files/1/0681/7054/7447/files/d77761a4-8916-4768-86a1-9c366648b294.png?v=1729840924";
  });
}

const remove4 = document.getElementById("remove4");
if (remove4) {
  remove4.addEventListener("click", function () {
    const hideFour = document.querySelector(".step-img.index-4");
    hideFour.innerHTML = "";
    const beforeFourth = document.querySelector(".before-fourth img");
    beforeFourth.classList.add("sb");
    beforeFourth.src = "https://cdn.shopify.com/s/files/1/0681/7054/7447/files/b6a5a8c5-b2b2-4394-b0fd-eb4813175e96.png?v=1729840924";
  });
}

const remove5 = document.getElementById("remove5");
if (remove5) {
  remove5.addEventListener("click", function () {
    const hideFive = document.querySelector(".step-img.index-5");
    hideFive.innerHTML = "";
    const beforeFifth = document.querySelector(".before-fifth img");
    beforeFifth.classList.add("sb");
    beforeFifth.src = "https://cdn.shopify.com/s/files/1/0681/7054/7447/files/cb88c961-ee9c-4ade-bb21-48722fca71e6.png?v=1729840924";
  });
}


// <!-- end style cstm-style  -->
nextButton.addEventListener("click", function () {
  updateTotalPrice();
  setTimeout(function () {
    var firstDiv = document.getElementById("firstDiv");
    var secondDiv = document.getElementById("secondDiv");

    if (firstDiv.innerHTML.trim() !== "") {
      secondDiv.classList.add("hidden");
    }
  }, 100);

  // Handling selected necklace image
  var selectedDiv = document.querySelector(
    ".content .div.nekless-img.selected"
  );
  if (selectedDiv) {
    var imgTag = selectedDiv.querySelector("img").outerHTML;
    var existingImg = mainImageContainer.querySelector(
      `.step-img.index-${currentStep}`
    );
    if (existingImg) {
      existingImg.innerHTML = imgTag;
    } else {
      mainImageContainer.innerHTML += `<div class="step-img index-${currentStep}" data-step="${currentStep}">${imgTag}</div>`;
    }

    var parentContentDiv = selectedDiv.closest(".content");
    if (parentContentDiv) {
      var parentContentId = parentContentDiv.id;
      for (var i = 0; i < clickDivs.length; i++) {
        if (clickDivs[i].getAttribute("data-content") === parentContentId) {
          clickDivs[i].classList.add("done");
          break;
        }
      }
    }
  }

  // Handling selected charm image
  var selectedCharm = document.querySelector(
    ".content .div.charm-img.selected"
  );
  if (selectedCharm) {
    var imgTagCharm = selectedCharm.querySelector("img").outerHTML;
    var existingImgCharm = charmImageContainer.querySelector(
      `.step-img.index-${currentStep}`
    );
    if (existingImgCharm) {
      existingImgCharm.innerHTML = imgTagCharm;
      // console.log("Charm image updated (existing)");
    } else {
      charmImageContainer.innerHTML += `<div class="step-img index-${currentStep}" data-step="${currentStep}">${imgTagCharm}</div>`;
      // console.log("Charm image added (new)");
    }

    var parentContentCharm = selectedCharm.closest(".content");
    if (parentContentCharm) {
      var parentContentIdCharm = parentContentCharm.id;
      for (var i = 0; i < clickDivs.length; i++) {
        if (
          clickDivs[i].getAttribute("data-content") === parentContentIdCharm
        ) {
          clickDivs[i].classList.add("done");
          break;
        }
      }
    }
  }

  // Handling engraving selection
  var selectedEngravingDiv = document.querySelector(
    ".content .div.selected.engraving"
  );
  if (selectedEngravingDiv) {
    engravingInputContainer.style.display = "block";
    doneButton.style.display = "block";
    nextButton.style.display = "none";
    prevButton.style.display = "block";
    for (var i = 0; i < contentDivs.length; i++) {
      contentDivs[i].style.display = "none";
    }
    return;
  }

  // Managing visibility of content and click divs
  for (var i = 0; i < contentDivs.length; i++) {
    contentDivs[i].style.display = "none";
  }
  for (var i = 0; i < clickDivs.length; i++) {
    clickDivs[i].style.display = "flex";
    // i comment for enable all div
    // clickDivs[i].classList.add("disabled");
  }
  if (currentStep < clickDivs.length - 1) {
    clickDivs[currentStep + 1].classList.remove("disabled");
    clickDivs[currentStep + 1].classList.add("enable");
  }
  for (var i = 1; i < clickDivs.length; i++) {
    if (clickDivs[i].classList.contains("enable")) {
      for (var j = 0; j <= i; j++) {
        clickDivs[j].classList.remove("disabled");
        clickDivs[j].classList.add("enable");
      }
    }
  }

  // Updating button states
  nextButton.disabled = true;
  selectButton.disabled = true;
  nextButton.style.display = "none";
  // Check all conditions
  prevButton.style.display = "none";
  selectButton.style.display = "none";
  addToCartButton.style.display = "flex";
});

doneButton.addEventListener("click", function () {
  var engravingTextElement = document.getElementById("engravingText");
  var engravingText = engravingTextElement.value;
  var existingEngravingDiv = document.querySelector(
    `.engraving-text.position-${currentStep}`
  );

  // Update or create engraving text div
  if (existingEngravingDiv) {
    existingEngravingDiv.textContent = engravingText;
  } else {
    charmImageContainer.innerHTML += `<div class="engraving-text position-${currentStep}">${engravingText}</div>`;
  }

  // Hide input containers and buttons
  engravingInputContainer.style.display = "none";
  doneButton.style.display = "none";
  nextButton.style.display = "none";
  prevButton.style.display = "none";
  addToCartButton.style.display = "flex";

  // Hide all content divs
  for (var i = 0; i < contentDivs.length; i++) {
    contentDivs[i].style.display = "none";
  }

  // Show and disable all clickDivs
  for (var i = 0; i < clickDivs.length; i++) {
    clickDivs[i].style.display = "flex";
    // i comment for enable all div
    // clickDivs[i].classList.add("disabled");
  }

  // Enable only the relevant clickDivs
  for (var i = 0; i < clickDivs.length; i++) {
    if (i <= currentStep) {
      // i comment for enable all div
      // clickDivs[i].classList.remove("disabled");
      clickDivs[i].classList.add(`enable${i}`);
    }
    if (i === currentStep + 1) {
      clickDivs[i].classList.remove("disabled");
    }
  }

  // Disable the select button and next button
  selectButton.disabled = true;
  nextButton.disabled = true;
  nextButton.style.display = "none";

  // Ensure add to cart button is displayed correctly at the last step
  if (currentStep === clickDivs.length - 1) {
    addToCartButton.style.display = "flex";
    nextButton.style.display = "none";
    selectButton.style.display = "none";
  }

  // Clear the engraving input field
  engravingTextElement.value = "";

});

// Adding click event listener to prevButton
prevButton.addEventListener("click", function () {
  // Check if the `step-img.index-4` div is empty
  var stepImgIndex4 = document.querySelector(".step-img.index-4");
  var stepImgIndex5 = document.querySelector(".step-img.index-5");

  // If `step-img.index-4` exists and is empty, also clear `step-img.index-5`
  if (stepImgIndex4 && stepImgIndex4.innerHTML.trim() === "") {
    if (stepImgIndex5) {
      stepImgIndex5.innerHTML = ""; // Clear the contents of `step-img.index-5`
    }
  }
// Select the `img` element inside the element with the `sixth-img` class
var sixthImg = document.querySelector(".sixth-img img");

// Set the image source URL
if (sixthImg) {
  sixthImg.src = "https://cdn.shopify.com/s/files/1/0681/7054/7447/files/cb88c961-ee9c-4ade-bb21-48722fca71e6.png?v=1729840924";
}



  // Set all `contentDivs` to `display: none`
  for (var i = 0; i < contentDivs.length; i++) {
    contentDivs[i].style.display = "none";
  }

  // Set all `clickDivs` to `display: flex`
  for (var i = 0; i < clickDivs.length; i++) {
    clickDivs[i].style.display = "flex";
  }

  // Check if `#firstDiv` has content, then show or hide the `addToCartButton` and `selectButton`
  var selectedProductId = document.querySelector("#firstDiv");
  if (selectedProductId && selectedProductId.innerHTML.trim() !== "") {
    addToCartButton.style.display = "flex";
    selectButton.style.display = "none";
  } else {
    selectButton.style.display = "block";
    addToCartButton.style.display = "none";
  }

  // Hide various elements
  prevButton.style.display = "none";
  engravingInputContainer.style.display = "none";
  doneButton.style.display = "none";
  nextButton.style.display = "none";
  selectButton.disabled = true;
});


// Ensuring correct initial state on page load
document.addEventListener("DOMContentLoaded", function () {
  nextButton.style.display = "none";
  nextButton.disabled = true;
  prevButton.disabled = true;
  selectButton.disabled = true;
  selectButton.style.display = "block"; // Hide prev button on load
  prevButton.style.display = "none"; // Hide prev button on load
  addToCartButton.style.display = "none";
  // totalButton.style.display = "none"; // Hide prev button on load
  engravingInputContainer.style.display = "none";
  doneButton.style.display = "none";
  for (var i = 0; i < contentDivs.length; i++) {
    contentDivs[i].style.display = "none";
  }
  for (var i = 0; i < clickDivs.length; i++) {
    // i comment for enable all div
    // clickDivs[i].classList.add("disabled");
  }
  clickDivs[0].classList.remove("disabled");
  clickDivs[0].classList.remove("active");
});

// Ensuring nextButton is enabled only when an item is selected
document.querySelectorAll(".content .div").forEach(function (item) {
  item.addEventListener("click", function () {
    nextButton.disabled = false;
    addToCartButton.style.display = "none";
    selectButton.style.display = "none";
    nextButton.style.display = "flex";
    // totalButton.style.display = "none";
  });
});

// button step first
const customTabButtons = document.querySelectorAll(".custom-tab-button");
const customContents = document.querySelectorAll(".custom-content");

customTabButtons.forEach((button) => {
  button.addEventListener("click", () => {
    // Remove custom-active class from all buttons and contents
    customTabButtons.forEach((btn) => btn.classList.remove("custom-active"));
    customContents.forEach((content) =>
      content.classList.remove("custom-active")
    );

    // Add custom-active class to clicked button and corresponding content
    button.classList.add("custom-active");
    const target = document.getElementById(button.dataset.target);
    target.classList.add("custom-active");
  });
});

// Set the first custom tab as active by default
customTabButtons[0].classList.add("custom-active");
customContents[0].classList.add("custom-active");

//
// button step second
const secondTabButtons = document.querySelectorAll(".second-tab-button");
const secondContents = document.querySelectorAll(".second-content");

secondTabButtons.forEach((button) => {
  button.addEventListener("click", () => {
    // Remove custom-active class from all buttons and contents
    secondTabButtons.forEach((btn) => btn.classList.remove("custom-active"));
    secondContents.forEach((content) =>
      content.classList.remove("custom-active")
    );

    // Add custom-active class to clicked button and corresponding content
    button.classList.add("custom-active");
    const target = document.getElementById(button.dataset.target);
    target.classList.add("custom-active");
  });
});

// Set the first custom tab as active by default
secondTabButtons[0].classList.add("custom-active");
secondContents[0].classList.add("custom-active");
//

// button step third
const thirdTabButtons = document.querySelectorAll(".third-tab-button");
const thirdContents = document.querySelectorAll(".third-content");

thirdTabButtons.forEach((button) => {
  button.addEventListener("click", () => {
    // Remove custom-active class from all buttons and contents
    thirdTabButtons.forEach((btn) => btn.classList.remove("custom-active"));
    thirdContents.forEach((content) =>
      content.classList.remove("custom-active")
    );

    // Add custom-active class to clicked button and corresponding content
    button.classList.add("custom-active");
    const target = document.getElementById(button.dataset.target);
    target.classList.add("custom-active");
  });
});
// Set the first custom tab as active by default
thirdTabButtons[0].classList.add("custom-active");
thirdContents[0].classList.add("custom-active");
// button step fourth
const fourthTabButtons = document.querySelectorAll(".fourth-tab-button");
const fourthContents = document.querySelectorAll(".fourth-content");

fourthTabButtons.forEach((button) => {
  button.addEventListener("click", () => {
    // Remove custom-active class from all buttons and contents
    fourthTabButtons.forEach((btn) => btn.classList.remove("custom-active"));
    fourthContents.forEach((content) =>
      content.classList.remove("custom-active")
    );

    // Add custom-active class to clicked button and corresponding content
    button.classList.add("custom-active");
    const target = document.getElementById(button.dataset.target);
    target.classList.add("custom-active");
  });
});

// Set the first custom tab as active by default
fourthTabButtons[0].classList.add("custom-active");
fourthContents[0].classList.add("custom-active");
//
addToCartButton.addEventListener("click", function () {
    // Generate a random number for this cart addition
    const randomProductNumber = Math.floor(Math.random() * 1000); // You can adjust the range as needed

    var selectedDivs = document.querySelectorAll(".step-img .variant");

    selectedDivs.forEach((selectedDiv) => {
        // Get the data-variant-id and data-engraving-id attributes
        var variantId = selectedDiv.getAttribute("data-variant-id");
        var engravingId = selectedDiv.getAttribute("data-engraving-id");
        var engravingIdSec = selectedDiv.getAttribute("data-engraving-id-sec");
        var engravingIdThird = selectedDiv.getAttribute("data-engraving-id-third");
        var engravingIdFourth = selectedDiv.getAttribute("data-engraving-id-fourth");

        // Initialize properties object with the random product number
        let properties = {
            product_number: randomProductNumber // Add the random product number here
        };

        // Determine which engraving text to use based on the variant ID
        if (variantId == engravingId) {
            const textOne = document.querySelector(".engraving-text.position-1").getAttribute('first-charm');
            properties.charm_position = textOne; // Add charm position for the first engraving
        } else if (variantId == engravingIdSec) {
            const textTwo = document.querySelector(".engraving-text.position-2").getAttribute('second-charm');
            properties.charm_position = textTwo; // Add charm position for the second engraving
        } else if (variantId == engravingIdThird) {
            const textThree = document.querySelector(".engraving-text.position-3").getAttribute('third-charm');
            properties.charm_position = textThree; // Add charm position for the third engraving
        } else if (variantId == engravingIdFourth) {
            const textFourth = document.querySelector(".engraving-text.position-4").getAttribute('fourth-charm');
            properties.charm_position = textFourth; // Add charm position for the fourth engraving
        }

        // Push the item to the formData with the properties
        formData.items.push({
            quantity: 1,
            id: parseInt(variantId),
            properties: properties // Add properties including product_number
        });
    });

    fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
    })
    .then((response) => response.json())
    .then((cart) => {
        // console.log('Success:', cart);
    })
    .catch((error) => {
        console.error("Error:", error);
    });

    setTimeout(function () {
        window.location.replace("/cart");
    }, 2000);

    addToCartButton.disabled = true;
    loader.style.display = "inline-block";
});


// popup js
document.addEventListener("DOMContentLoaded", () => {
  const cstmButtons = document.querySelectorAll(".cstm-popup-btn");
  const cstmPopup = document.getElementById("cstm-popup");
  const overlay = document.getElementById("popupOverlay");
  const popupContents = document.querySelectorAll(".popup-content");
  const closeButtons = document.querySelectorAll(".cstm-close-btn");

  cstmButtons.forEach((button, index) => {
    button.addEventListener("click", () => {
      popupContents.forEach((content, contentIndex) => {
        content.style.display = contentIndex === index ? "block" : "none";
      });
      cstmPopup.style.display = "block";
      document.getElementById("popupOverlay").style.display = "block";
      document.querySelector(".cstm-popup").classList.add("show");
      document.getElementById("popupOverlay").classList.add("show");
    });
  });

  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener("click", () => {
      // cstmPopup.style.display = 'none';
      document.querySelector(".cstm-popup").classList.remove("show");
      document.getElementById("popupOverlay").classList.remove("show");
      document.getElementById("popupOverlay").style.display = "none";
    });
  });

  window.addEventListener("click", (event) => {
    if (event.target === overlay) {
      // cstmPopup.style.display = 'none';
      document.querySelector(".cstm-popup").classList.remove("show");
      document.getElementById("popupOverlay").classList.remove("show");
      document.getElementById("popupOverlay").style.display = "none";
    }
  });
});
// product popup slider
document
  .getElementById("seco-inspirationBtn")
  .addEventListener("click", function () {
    document.getElementById("seco-overlay").style.opacity = "1";
    document.getElementById("seco-overlay").style.pointerEvents = "auto";
    document.getElementById("seco-popup").classList.add("active");
  });

document.getElementById("seco-overlay").addEventListener("click", function () {
  document.getElementById("seco-popup").classList.remove("active");
  document.getElementById("seco-overlay").style.opacity = "0";
  document.getElementById("seco-overlay").style.pointerEvents = "none";
});
document
  .getElementById("popup-close-btn")
  .addEventListener("click", function () {
    document.getElementById("seco-popup").classList.remove("active");
    document.getElementById("seco-overlay").style.opacity = "0";
    document.getElementById("seco-overlay").style.pointerEvents = "none";
  });
const swiper = new Swiper(".swiper-2", {
  // Optional parameters
  direction: "horizontal",
  loop: true,
  spaceBetween: 10,
  slidesPerView: 1,
  loop: true,

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next-2",
    prevEl: ".swiper-button-prev-2",
  },
  breakpoints: {
    1024: {
      slidesPerView: 5,
    },
    768: {
      slidesPerView: 4,
    },
    500: {
      slidesPerView: 1,
    },
  },
});
const mySwiper = new Swiper(".swiper-1", {
  // Optional parameters
  direction: "horizontal",
  loop: true,
  spaceBetween: 10,
  slidesPerView: 1,
  loop: true,

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next-1",
    prevEl: ".swiper-button-prev-1",
  },
});
